import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import IQuote from "apiConsumers/kenticoApiConsumer/models/quotes/IQuote";
import { fonts } from "theme";
import { useMediaQuery } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        quoteContentText: {
            fontWeight: 900,
            fontFamily: fonts.secondary,
            textTransform: "uppercase",
        },
    })
);

interface IProps extends HTMLAttributes<HTMLDivElement> {
    quote: IQuote;
}

export default function Quote(props: IProps) {
    const classes = useStyles();
    const { quote, className, ...rest } = props;

    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const xsScreen = useMediaQuery(theme.breakpoints.down("xs"));

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            <Typography
                variant={xsScreen ? "subtitle1" : smScreen ? "h6" : "h4"}
                align="center"
                className={classes.quoteContentText}
            >
                {quote.content}
            </Typography>
            <Typography variant={xsScreen ? "subtitle1" : smScreen ? "h6" : "h5"} align="center">
                {"- "}
                {quote.source}
            </Typography>
        </div>
    );
}
